/*!
 * Service Discovery
 * Resolves URIs and domains for the current env
 */
//WEBMESS-209: Getting the service environments from genesys service discovery npm package
const serviceDiscoveryPkg =
require('@genesys/service-discovery-web-internal');
const serviceEnvironments = serviceDiscoveryPkg.getEnvironments({}); // to get all the service environments including dev and test
// Define any service that has an env-specific domain here
const SERVICES = {
  staticAssets: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
  },
  configs: {
    subdomain: 'api-cdn',
    regionalSubdomain: 'api-cdn',
    path: '/webdeployments/v1/deployments',
  },
  journeyPlugin: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/journey/messenger-plugins/journey.min.js',
  },
  supportCenterPlugin: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/support-center/support-center-plugins/main.min.js',
  },
  offersHelper: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/journey/messenger-plugins/offersHelper.min.js',
  },
  cobrowseService: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/cobrowse-next/sharer.min.js',
  },
  videoHelper: {
    subdomain: 'apps',
    path: '/video-service/videoHelper.min.js',
  },
  videoService: {
    subdomain: 'apps',
    path: '/video-service/videoService.min.js',
  },
  vendorsPlugin: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/genesys-bootstrap/plugins/genesysvendors.min.js',
  },
  messagingTransport: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/messenger/genesyscloud-messaging-transport.mod.js',
  },
  messengerMain: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/messenger/main.min.js',
  },
  messengerEngage: {
    subdomain: 'apps',
    regionalSubdomain: 'app-regional',
    path: '/messenger/engage.min.js',
  },
  apiV2: {
    subdomain: 'api',
    regionalSubdomain: 'api', // same as subdomain since there is no change but they key changes.
    path: '/api/v2',
  },
};

class ServiceDiscovery {
  static SERVICES = SERVICES;

  constructor(env, bRegionalSubdomain) {
    let sEnv = env;
    // maintains the existing as per the environments specified in the npm package

    sEnv = sEnv.toLowerCase();

    if (sEnv === 'use1') {
      sEnv = 'prod';
    } else if (sEnv === 'fedramp-use2') {
      sEnv = 'fedramp-use2-core';
    } else if (!['dev', 'test'].includes(sEnv)) {
      // WEBMESS-1073: When the "env" property in single snippet already includes "prod-xxxx", then just pass it as-is. If not, then prepend it.
      sEnv = sEnv.includes('prod') || sEnv.includes('fedramp-use2-core') ? sEnv : `prod-${sEnv}`;
    }

    const domain = serviceEnvironments.find(serviceEnv => serviceEnv.name === sEnv).publicDomainName;

    if (!domain) {
      throw new Error(`invalid environment ${sEnv}`);
    }

    this.environment = sEnv;
    this.domain = domain;
    this.bRegionalSubdomain = bRegionalSubdomain;
  }

  getUri(name) {
    const service = SERVICES[name];

    if (!service) {
      return;
    }

    const {
      protocol = 'https:',
      subdomain,
      regionalSubdomain,
      path,
    } = service;

    const subDomain = typeof this.bRegionalSubdomain === 'boolean' && this.bRegionalSubdomain ? regionalSubdomain : subdomain;

    return `${protocol}//${subDomain}.${this.domain}${path || ''}`;
  }

  getDomain(name) {
    const service = SERVICES[name];

    if (!service) {
      return;
    }

    const { subdomain } = service;

    return `${subdomain}.${this.domain}`;
  }

  resolveAllServices() {
    const serviceInfo = {};

    for (const service in SERVICES) {
      if (Object.prototype.hasOwnProperty.call(SERVICES, service)) {
        const uri = this.getUri(service);
        const domain = this.getDomain(service);

        serviceInfo[service] = {
          uri,
          domain,
        };
      }
    }

    return serviceInfo;
  }
}

export default ServiceDiscovery;
